var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8334V1.66669L16.6667 5.00002L10 8.33335",
    stroke: "#667085",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1251 8.52503C17.5686 9.89182 17.6101 11.3572 17.2447 12.7469C16.8792 14.1366 16.1223 15.3921 15.0639 16.3639C14.0055 17.3358 12.6902 17.9832 11.2745 18.2291C9.85874 18.4749 8.40218 18.3089 7.07808 17.7508C5.75397 17.1927 4.61808 16.2659 3.80552 15.0808C2.99296 13.8957 2.53795 12.5021 2.49462 11.0658C2.45129 9.62953 2.82147 8.21105 3.56111 6.97911C4.30076 5.74716 5.37873 4.75363 6.66678 4.1167",
    stroke: "#667085",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66686 8.33337C6.24928 8.88923 5.97743 9.54073 5.87607 10.2285C5.7747 10.9163 5.84706 11.6186 6.08653 12.2712C6.32601 12.9239 6.72499 13.5063 7.24714 13.9654C7.76928 14.4244 8.39799 14.7455 9.07597 14.8993C9.75396 15.0532 10.4597 15.035 11.1288 14.8464C11.798 14.6577 12.4093 14.3046 12.907 13.8193C13.4048 13.3339 13.7732 12.7317 13.9787 12.0676C14.1842 11.4034 14.2202 10.6984 14.0835 10.0167",
    stroke: "#667085",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/Goals.5fcadec5fabdc3237fd4942c8552025b.svg";
export { ForwardRef as ReactComponent };